import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Thumbs, Scrollbar } from 'swiper/modules';

Swiper.use([Navigation, Pagination, Autoplay, Thumbs, Scrollbar]);

export default (obj, options = null) => ({
    slider: null,

    init() {
        new Swiper(obj, options);
    }
})